import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as de, useAttrs as ie, useCssModule as ce, ref as o, computed as h, watch as ue, onMounted as me, onUnmounted as fe, createBlock as ve, openBlock as he, Teleport as pe, createElementVNode as l, normalizeClass as d, unref as n, mergeProps as ye, renderSlot as S, normalizeStyle as O, createVNode as P, createCommentVNode as be, toDisplayString as ge, withCtx as Ce, nextTick as R } from "vue";
import { debounce as we } from "../../utils/debounce.mjs";
import V from "tabbable";
import { CdrSpaceTwoX as X, CdrSpaceOneX as Ee, CdrBreakpointSm as xe } from "@rei/cdr-tokens";
import Se from "./onTransitionEnd.mjs";
import _e from "../button/CdrButton.vue.mjs";
import ke from "../icon/comps/x-lg.vue.mjs";
import j from "../../utils/mapClasses.mjs";
const Be = ["tabIndex"], He = ["role", "aria-label"], Le = ["tabIndex"], Ne = "cdr-modal", Re = /* @__PURE__ */ de({
  name: "CdrModal",
  inheritAttrs: !1,
  __name: "CdrModal",
  props: {
    /**
     * Toggles the state of the modal
     * @demoIgnore true
     */
    opened: {
      type: Boolean,
      required: !0
    },
    /**
     * Sets `aria-label` and modal title text. Can also use title slot to set title.
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Toggles the modal title text, which comes from `label` prop or `title` slot.
     */
    showTitle: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Text for aria-describedby attribute. Applied to modal content element
     */
    ariaDescribedby: {
      type: String,
      required: !1,
      default: null
    },
    /**
     * Sets the `role` attribute on the modal content element
     * @values dialog, alertDialog
     */
    role: {
      type: String,
      required: !1,
      default: "dialog"
    },
    /**
     * Sets unique `id` for modal
     */
    id: {
      type: String,
      required: !1,
      default: null
    },
    /** Adds custom class to the `cdr-modal__overlay` div */
    overlayClass: String,
    /** Adds custom class to the `cdr-modal__outerWrap` div */
    wrapperClass: String,
    /** Adds custom class to the `cdr-modal__innerWrap` div */
    contentClass: String,
    /** Sets duration for modal's close animation */
    animationDuration: {
      type: Number,
      default: 300
    }
  },
  emits: {
    closed: null
  },
  setup(a, {
    emit: F
  }) {
    const u = a, K = F, U = ie(), r = ce();
    let y, b;
    const g = o(!u.opened), C = o(!1), c = o({
      x: void 0,
      y: void 0
    }), _ = o(0), k = o(0), B = o(0), H = o(0), L = o(0), N = o(0), T = o(!1), m = o(null), f = o(null), v = o(null), A = o(null), w = () => {
      R(() => {
        var e, t, s, i, p;
        k.value = window.innerHeight, T.value = window.innerWidth < +xe, _.value = ((e = A.value) == null ? void 0 : e.offsetHeight) || 0, B.value = ((t = v.value) == null ? void 0 : t.scrollHeight) || 0, H.value = ((s = v.value) == null ? void 0 : s.offsetHeight) || 0, L.value = ((i = v.value) == null ? void 0 : i.offsetWidth) || 0, N.value = ((p = v.value) == null ? void 0 : p.clientWidth) || 0;
      });
    }, E = (e) => {
      K("closed", e);
    }, W = ({
      key: e
    }) => {
      switch (e) {
        case "Escape":
        case "Esc":
          E();
          break;
      }
    }, $ = (e) => {
      var z;
      const {
        documentElement: t
      } = document;
      if ((z = m.value) != null && z.contains(e.target) || !t) return;
      const s = V(t), i = V(m.value), p = s.indexOf(e.target), se = s.indexOf(i[0]), M = p < se ? i[i.length - 1] : i[0];
      M && M.focus();
    }, q = we(() => {
      w();
    }, 300), Y = () => {
      const {
        documentElement: e,
        body: t
      } = document;
      c.value = {
        x: window.scrollX || (e || {}).scrollLeft || (t || {}).scrollLeft || 0,
        y: window.scrollY || (e || {}).scrollTop || (t || {}).scrollTop || 0
      }, e && (e.classList.add("cdr-modal__noscroll"), e.style.top = `-${c.value.y}px`, e.style.left = `-${c.value.x}px`), t && t.classList.add("cdr-modal__noscroll");
    }, G = () => {
      const {
        documentElement: e,
        body: t
      } = document;
      t && t.classList.remove("cdr-modal__noscroll"), e && (e.classList.remove("cdr-modal__noscroll"), e.style.top = "", e.style.left = "");
    }, J = () => {
      document.addEventListener("focusin", $, !0), document.addEventListener("keydown", W);
    }, x = [];
    let D = !1;
    const Q = () => {
      const e = ["body > *", ":not(script)", ":not(style)", ":not([aria-hidden=true])"];
      document.querySelectorAll(e.join("")).forEach((s) => {
        s !== f.value && getComputedStyle(s).getPropertyValue("display") !== "none" && x.push(s);
      }), D = !0;
    }, Z = () => {
      D || Q(), x.forEach((e) => {
        e.setAttribute("aria-hidden", "true");
      });
    }, ee = () => {
      x.forEach((e) => {
        e.removeAttribute("aria-hidden");
      });
    }, I = () => {
      Z();
      const {
        activeElement: e
      } = document;
      Y(), C.value = !0, g.value = !1, b = e, R(() => {
        m.value && m.value.focus(), w(), J(), setTimeout(() => {
          f.value && (f.value.scrollTop = 0), w();
        });
      });
    }, te = () => {
      ee();
      const {
        documentElement: e
      } = document;
      document.removeEventListener("keydown", W), document.removeEventListener("focusin", $, !0), C.value = !1, y = Se(f.value, () => {
        C.value || (y && y(), G(), g.value = !0, e && (e.style.scrollBehavior = "auto"), c.value.x !== void 0 && c.value.y !== void 0 && window.scrollTo(c.value.x, c.value.y), e && (e.style.scrollBehavior = ""), b && b.focus());
      }, u.animationDuration + 16);
    }, oe = h(() => ({
      ...U,
      "aria-describedby": u.ariaDescribedby,
      id: u.id
    })), le = h(() => {
      const e = Number(X), t = Number(X) + Number(Ee);
      return T.value ? e : t + e;
    }), ne = h(() => k.value - _.value - le.value), ae = h(() => {
      const e = B.value > H.value, t = L.value - N.value > 0;
      return e && t ? 4 : e ? 12 : 0;
    }), re = h(() => ({
      maxHeight: `${ne.value}px`,
      paddingRight: `${ae.value}px`
    }));
    return ue(() => u.opened, (e, t) => {
      !!e != !!t && (e ? I() : te());
    }), me(() => {
      u.opened && I(), window.addEventListener("resize", q);
    }), fe(() => {
      window.removeEventListener("resize", q);
    }), (e, t) => (he(), ve(pe, {
      to: "body"
    }, [l("div", {
      class: d(n(j)(n(r), Ne, a.opened ? "" : "cdr-modal--closed")),
      ref_key: "wrapperEl",
      ref: f
    }, [l("div", {
      class: d([n(r)["cdr-modal__outerWrap"], a.wrapperClass])
    }, [l("div", {
      "aria-hidden": "true",
      onClick: E,
      class: d([n(r)["cdr-modal__overlay"], a.overlayClass])
    }, null, 2), l("div", {
      tabIndex: a.opened ? "0" : void 0
    }, null, 8, Be), l("div", ye({
      ref_key: "modalEl",
      ref: m,
      class: n(j)(n(r), "cdr-modal__contentWrap", "cdr-modal__dialog"),
      tabIndex: "-1",
      role: a.role,
      "aria-modal": "true",
      "aria-label": a.label
    }, oe.value), [S(e.$slots, "modal", {}, () => [l("div", {
      class: d([n(r)["cdr-modal__innerWrap"], a.contentClass]),
      style: O(g.value ? {
        display: "none"
      } : void 0)
    }, [l("section", null, [l("div", {
      class: d(n(r)["cdr-modal__content"])
    }, [l("div", {
      class: d(n(r)["cdr-modal__header"]),
      ref_key: "headerEl",
      ref: A
    }, [l("div", {
      class: d(n(r)["cdr-modal__title"])
    }, [a.showTitle ? S(e.$slots, "title", {
      key: 0
    }, () => [l("h1", null, ge(a.label), 1)]) : be("", !0)], 2), P(_e, {
      class: d(n(r)["cdr-modal__close-button"]),
      "icon-only": "",
      "with-background": !0,
      onClick: E,
      "aria-label": "Close"
    }, {
      icon: Ce(() => [P(ke, {
        "inherit-color": ""
      })]),
      _: 1
    }, 8, ["class"])], 2), l("div", {
      class: d(n(r)["cdr-modal__text-content"]),
      style: O(re.value),
      role: "document",
      ref_key: "contentEl",
      ref: v,
      tabindex: "0"
    }, [S(e.$slots, "default")], 6)], 2)])], 6)])], 16, He), l("div", {
      tabIndex: a.opened ? "0" : void 0
    }, null, 8, Le)], 2)], 2)]));
  }
});
export {
  Re as default
};
